import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/api";

export default function ProtectedRoute({ roles, children }) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading || user === undefined) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-brand-ink text-white" data-testid="auth-loading">
                <div className="flex flex-col items-center gap-4">
                    <div className="h-10 w-10 animate-spin rounded-full border-2 border-brand-orange border-t-transparent" />
                    <div className="text-sm uppercase tracking-widest text-white/60">Chargement…</div>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    if (roles && roles.length > 0 && !roles.includes(user.role)) {
        // Not authorized — redirect to their natural home
        if (user.role === "admin") return <Navigate to="/admin" replace />;
        if (user.role === "formateur") {
            const target = user.must_change_password || !user.onboarding_completed ? "/formateur/onboarding" : "/formateur";
            return <Navigate to={target} replace />;
        }
        return <Navigate to="/" replace />;
    }

    return children;
}
